import styles from './GiftCardForm.module.scss';

export const options = {
  customClasses: {
    inputGeneral: styles.textareaStyles,
    characterCount: styles.characterCount,
    theme: 'Sportscraft'
  },
};
